import ExploreBar from "@bmi-digital/components/explore-bar";
import Section from "@bmi-digital/components/section";
import { replaceSpaces } from "@bmi-digital/components/utils";
import { graphql } from "gatsby";
import React from "react";
import { devLog } from "../utils/devLog";
import { useSiteContext } from "./Site";
import { toButtonActionProps } from "./link/utils";
import { ExploreBarData } from "./ExploreBar";
import type { PayloadExploreBarSection } from "../types/payload";
import type { ButtonProps } from "@bmi-digital/components/button";

export type ExploreBarSectionData = ExploreBarData &
  Pick<PayloadExploreBarSection, "blockType">;

const ExploreBarSection = ({ data }: { data: ExploreBarSectionData }) => {
  const { countryCode } = useSiteContext();
  const { title } = data;
  // Navigation is being used as the explore bar so bad values need filtering out.
  const links = data.links.filter((link) => {
    if (Object.keys(link).length) {
      return true;
    }
    devLog(
      `Only Links can be used if Navigation is being used as an Section. See Explore Bar labelled "${title}".`
    );
  });

  return (
    <Section data-testid={`explorer-bar-section-${replaceSpaces(title)}`}>
      <ExploreBar
        heading={title}
        links={
          links.map<ButtonProps>((link) => ({
            children: link.label,
            ...toButtonActionProps(link, countryCode)
          })) as [ButtonProps, ...ButtonProps[]]
        }
      />
    </Section>
  );
};

export default ExploreBarSection;

export const query = graphql`
  fragment ExploreBarSectionFragment on PayloadExploreBarSection {
    blockType
    ...ExploreBarFragment
  }
`;
